import React, { useState, useEffect} from "react";
import axios from "axios";
import { LoyaltyTwoTone } from "@material-ui/icons";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { useHistory } from "react-router-dom";

// Icons
import LocalShippingTwoToneIcon from "@material-ui/icons/LocalShippingTwoTone";
import ShoppingCartTwoToneIcon from "@material-ui/icons/ShoppingCartTwoTone";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ShoppingBasketTwoToneIcon from '@material-ui/icons/ShoppingBasketTwoTone';
// Components
import CheckDetailsTable from "./CheckDetailsTable"; //reused table component
import PurchaseOrderAllocationTable from "../Purchases/PurchaseOrderAllocationTable";
//React Router (for getting parameters)
import {  useParams, NavLink } from "react-router-dom";
import {get_cookies, isLoggedIn} from "../../components/Cookies/Cookies";
import Preloader from "../../components/Preloader/Preloader";
//number format plugin
import numeral from "numeral";


const useStyles = makeStyles({
	card: {
		marginBottom: "1rem",
	},
	cardHeader: {
		borderBottom: "1px solid #59b259",
		padding: "1.3rem 24px 2rem 24px",
	},
	title: {
		marginTop: "0",
		color: "#339933",
		fontWeight: "700",
		fontSize: "1.1rem",
	},
	subTitle: {
		fontSize: "0.8rem",
		marginBottom: "0.5rem",
		fontWeight: "700",
		textTransform: "uppercase",
		color: "#c1c3d8",
		display:"none"
	},
	infoContainer: {
		marginBottom: "2rem",
		backgroundColor: "rgba(89, 178, 89, 0.09)",
		padding: "1rem",
		border: "1.5px solid #59b259",
		borderRadius: "5px",
	},
	infoTitle: {
		fontWeight: "700",
		fontSize: "14px",
	},
	infoContent: {
		fontSize: "14px",
	},
	buttonContainer: {
		textAlign: "right",
		"& button": {
			marginLeft: "0.5rem !important",
		},
	},
	infoTotal: {
		display: "flex",
		justifyContent: "flex-end",
		alignItems: "center",
		marginTop: "1rem",
	},
	infoTotalItem: {
		padding: "0.5rem 1rem",
		border: "1px solid #59b259",
		borderRadius: "5px",
		display: "flex",
		alignItems: "center",
		marginBottom: "0.5rem",
		fontWeight: "700",
	},
	infoTotalIcon: {
		marginRight: "0.5rem",
		color: "#4caf50 !important",
	},
	textarea: {
		width: "100%",
		marginTop: "1rem",
	},
	miniTitle: {
		fontSize: "0.8rem",
		marginBottom: "0.5rem",
		fontWeight: "700",
		textTransform: "uppercase",
		color: "#339933",
	},
});

const CheckViewReference = () => {
	const { chkno, branchidno } = useParams();
	const [supplierInfo, setSupplierInfo] = useState(null);
	const [warehouse, setWarehouse] = useState([]);
	const classes = useStyles();

	const [checkDetails, setCheckDetails] = useState([]); //data to display in check table
	const [allocation, setAllocation] = useState([]); //data to display in allocation table

	const [poTotal, setPoTotal] = useState(0);
	const [shipTotal, setShipTotal] = useState(0);
	const [notes, setNotes] = useState('');

	let history = useHistory();

	// componentDidMount / document.ready ?
	useEffect(() => {
			data();
	}, []);

	const x = 0;
	useEffect(() => { //
		isLoggedIn();
	}, [x]);

	const data = async () => {
		// const po_details = await axios.get(process.env.REACT_APP_API_URL+'get_po_details_reference', {
		 await axios.get(process.env.REACT_APP_API_URL+'check_view_reference', {
			params:{
				chkno: chkno,
				jc_u_idno: branchidno
			}
		}).then((res) => {
			console.log(res.data);
			setCheckDetails(res.data.data[2].check_details);
			setSupplierInfo(res.data.data[0].supplier_details);
			setShipTotal(res.data.data[0].supplier_details.shipping);
			setPoTotal(res.data.data[2].check_details[0].amount);
			// setGrandTotal(res.data.data[1].supplier_details.grand_total);
			setNotes(res.data.data[0].supplier_details.notes);
			setAllocation(res.data.data[1].allocations);
		}).catch((error) => {
			console.log(error);
		});
	};	



	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<LoyaltyTwoTone />
				</div>
				<NavLink to={"/purchases"}><h4 style={{color:"#339933"}}>Purchases</h4></NavLink>
				<ArrowForwardIosIcon  fontSize="small" color="disabled"/>
				<NavLink to={"/purchases/purchases-order-return-transaction-history"}><h4 style={{color:"#339933"}}>Purchase Order Return Transaction History</h4></NavLink>
				<ArrowForwardIosIcon  fontSize="small" color="disabled"/>
				<h4>Check View Reference #{chkno}</h4>
				{/* <h4>supplier id: {supid} - delivery_date: {delivery_date}</h4> test if param values were passed*/}
			</div>
		{supplierInfo ? (			<div className="page-container">
				<Card className={classes.card}>
					<div className={classes.cardHeader}>
						<Grid container spacing={0} style={{justifyContent: "flex-end"}}>
							<Grid item xs={12} sm={8}>
								<div className={classes.subTitle}>
									Check View Reference
								</div>
								<div className={classes.title}>
									Check View Reference
								</div>
							</Grid>
							<Grid
								item
								xs={2}
								style={{textAlign: "right"}}
							>
								{/* <PurchaseEditShipping shipTotal={shipTotal} setShipTotal={setShipTotal}/> */}
							</Grid>
							<Grid
								item
								xs={2}
								className={classes.buttonContainer}
							>
								{/* <PurchaseAddItem addItem={addItem} supplierItem={supplierItem}/> */}
							</Grid>
					  </Grid>
					</div>
					<CardContent>
						<div className={classes.infoContainer}>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={4} className={classes.infoTitle}>
									Date: 
								</Grid>
								<Grid
									item
									xs={12} sm={8}
									className={classes.infoContent}
								>
									{supplierInfo.date_add || "Date"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={4} className={classes.infoTitle}>
									Pay To: 
								</Grid>
								<Grid
									item
									xs={12} sm={8}
									className={classes.infoContent}
								>
									{supplierInfo.pay_to || "Pay To"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={4} className={classes.infoTitle}>
									Cleared:
								</Grid>
								<Grid
									item
									xs={12} sm={8}
									className={classes.infoContent}
								>
									{supplierInfo.cleared || "Cleared"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={4} className={classes.infoTitle}>
									Printed:
								</Grid>
								<Grid
									item
									xs={12} sm={8}
									className={classes.infoContent}
								>
									{supplierInfo.printed || "Printed"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={4} className={classes.infoTitle}>
									Allocation:
								</Grid>
								<Grid
									item
									xs={12} sm={8}
									className={classes.infoContent}
								>
									{supplierInfo.allocation || "Allocation"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={4} className={classes.infoTitle}>
									Balance:
								</Grid>
								<Grid
									item
									xs={12} sm={8}
									className={classes.infoContent}
								>
									{numeral(supplierInfo.balance).format('0,0.00')}
								</Grid>
							</Grid>
						</div>
						<PurchaseOrderAllocationTable items={allocation} type={0} branchidno={branchidno}/>
						<div className={classes.miniTitle}>
									Check Details
						</div>
						<CheckDetailsTable items={checkDetails}/>
						<div className={classes.infoTotal}>
							<div className={classes.infoTotalContent}>
								<div className={classes.infoTotalItem}>
									<ShoppingCartTwoToneIcon
										className={classes.infoTotalIcon}
									/>
									{"Total: "+ numeral(poTotal).format('0,0.00')}
								</div>	
							</div>
						</div>
						<TextField
							label="Notes"
							multiline
							rows={4}
							variant="outlined"
							value={notes || ''}
							className={classes.textarea}
							InputProps={{
								readOnly: true,
							  }}
						/>
					</CardContent>
				</Card>
			</div>
		) : (<Preloader />)}

		</div>
	);
};

export default CheckViewReference;
